export const FILTER_ARR_START_CHAR = '(';
export const FILTER_ARR_END_CHAR = ')';
export const COLUMNS_ORDER_SURFIX = 'Order';
